module.exports = __webpack_public_path__ + "media/super.b014223e.mp3";